import { createSlice } from '@reduxjs/toolkit';
import _isEmpty from 'lodash';
import { createReducerNames } from '../../core/helpers/default';

const name = 'teams';

const reducersKeys = {
  getTeamsRequest: 'getTeamsRequest',
  getTeamsSuccess: 'getTeamsSuccess',
  getTeamsFailure: 'getTeamsFailure',
  getOrganizationsRequest: 'getOrganizationsRequest',
  getOrganizationsSuccess: 'getOrganizationsSuccess',
  getOrganizationsFailure: 'getOrganizationsFailure',
  setOrganizationId: 'setOrganizationId',
  createTeamRequest: 'createTeamRequest',
  createTeamSuccess: 'createTeamSuccess',
  createTeamFailure: 'createTeamFailure',
  updateTeamRequest: 'updateTeamRequest',
  updateTeamSuccess: 'updateTeamSuccess',
  updateTeamFailure: 'updateTeamFailure',
  deleteTeamRequest: 'deleteTeamRequest',
  deleteTeamSuccess: 'deleteTeamSuccess',
  deleteTeamFailure: 'deleteTeamFailure',
};

const initialState = {
  teams: [],
  organizations: [],
  organizationId: null,
  loaded: false,
  loading: false,
  creatingInProcess: false,
  error: null,
};

const teams = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getTeamsRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    [reducersKeys.getTeamsSuccess]: (state, { payload }) => {
      state.teams = payload.teams;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getTeamsFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.setOrganizationId]: (state, { payload }) => {
      state.organizationId = payload.organizationId;
    },
    [reducersKeys.getOrganizationsRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    [reducersKeys.getOrganizationsSuccess]: (state, { payload }) => {
      state.organizations = payload.organizations;
      state.organizationId = _isEmpty(payload.organizations) ? payload.organizations[0].id : '';
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getOrganizationsFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.createTeamRequest]: (state) => {
      state.creatingInProcess = true;
    },
    [reducersKeys.createTeamSuccess]: (state, { payload }) => {
      state.teams = [...state.teams, payload.team];
      state.creatingInProcess = false;
    },
    [reducersKeys.createTeamFailure]: (state) => {
      state.creatingInProcess = false;
    },
    [reducersKeys.updateTeamRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.updateTeamFailure]: (state) => {
      state.loading = false;
    },
    [reducersKeys.deleteTeamRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.deleteTeamFailure]: (state) => {
      state.loading = false;
    },
  },
});

export const teamReducers = createReducerNames(name, reducersKeys);
export const { actions } = teams;

export default teams.reducer;
